module.exports = __webpack_public_path__ + "img/digi-marktng-broken.32774271.png";